export class RCSInteractionDetails {
  interactionID: number;
  interactionType: string;
  interactionDate: Date;
  suggestionText: string;
  suggestionType: string;
  number: string;
  contactID: number;
  totalCount: number;
}
